// extracted by mini-css-extract-plugin
export default {"root":"EditListingTermsOfSalePanel_root__t1E85","form":"EditListingTermsOfSalePanel_form__K0Ca3","container":"EditListingTermsOfSalePanel_container__OdTg0"};